// Date formatting utilities — replaces Vue.filter('DateFormat', ...) etc. from app.ts
import moment from 'moment';
const DATE_FORMAT_DISPLAY_LOCAL_MOMENT = (window as any).DATE_FORMAT_DISPLAY_LOCAL_MOMENT;

export function formatDate(value: string | Date): string {
  return moment(value).format('DD MMM YYYY  HH:mm').toString();
}

export function formatDate2(value: string | Date): string {
  return moment(value).format(DATE_FORMAT_DISPLAY_LOCAL_MOMENT).toString();
}

export function formatDate3(value: string | Date): string {
  return moment(value).format('DD-MM-YY HH:mm').toString();
}
